import clsx from "clsx";
import { AlertTriangleIcon, Loader2, User2 } from "lucide-react";
import { MSUser } from "models/msUser";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import graph from "services/graph";

interface MSAvatarProps {
    microsoftId?: string;
    showName?: boolean;
    showAvatar?: boolean;
    className?: string;
    subtitle?: string;
    msUser?: MSUser | null;
    size?: number;
}
export function MSAvatar({microsoftId, showName, subtitle, className, msUser, showAvatar = true, size = 48}: MSAvatarProps) {
    const [img, setImg] = useState<null | Blob>(null);
    const [user, setUser] = useState<null | MSUser>(null);
    const [error, setError] = useState(false);
    const [fetchUser, setFetchUser] = useState(false);
    const [fetchAvatar, setFetchAvatar] = useState(false);
    const { t } = useTranslation()

    useEffect(() => {
        if (fetchAvatar || fetchUser)
            return;
        setImg(null);
        setError(false);
        if (msUser) {
            setUser(msUser);
            setFetchUser(false);
        }
        if (showName && !msUser) {
            setFetchUser(true);
            graph.get(microsoftId ? `/users/${microsoftId}` : "/me")
                .then(res => {
                    if (res.status === 200 && res.data) {
                        setUser(res.data);
                    }
                })
                .catch(() => setError(true))
                .finally(() => setFetchUser(false));
        }
        if (showAvatar) {
            setFetchAvatar(true);
            graph.get(microsoftId ? `/users/${microsoftId}/photos/48x48/$value` : "/me/photos/48x48/$value", {responseType: "blob"})
                .then(res => {
                    if (res.status === 200) 
                        setImg(res.data)
                })
                .catch(() => {})
                .finally(() => setFetchAvatar(false));
        }
    }, [microsoftId, msUser])


    return <div className={clsx("flex gap-2 items-center font-bold truncate", className)}>
        {showAvatar && <span data-error={error} style={{width: `${size}px`, height: `${size}px`}} className="relative flex-shrink-0 rounded-full bg-zinc-300 data-[error=true]:bg-red-300 flex justify-center items-center text-zinc-400 overflow-hidden">
            {fetchAvatar ? 
                <Loader2 className="animate-spin" /> 
            : error ? <AlertTriangleIcon className="text-red-600" /> : <User2 />}
            {img && <img style={{width: `${size}px`, height: `${size}px`}} src={URL.createObjectURL(img)} alt="ProfilePhoto" />}
        </span>}
        {showName && 
        <div className="flex flex-col">
            {fetchUser ? 
                <div className="rounded h-4 w-32 bg-zinc-300 animate-pulse"/> 
                : error ? <span>{t("microsoft.error")}</span> : <span>{user?.displayName}</span>}
            {subtitle && <span className="text-xs font-normal text-zinc-400">{subtitle}</span>}
        </div>}
    </div>
}